import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser, selectIsAuthenticated, selectIsLoading } from "../../Apis/store/authSlice";

const LoginGuard = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);
  const isLoading = useSelector(selectIsLoading);
  const navigate = useNavigate();

  // Handle redirect when user is authenticated
  useEffect(() => {
    if (isAuthenticated && user && !isLoading) {
      const redirectPath = user.role === "أدمن" ? "/dashboard/GeneralLooka" : "/dashboard/GeneralLooks";
      
      // Use a small delay to ensure React Router is ready
      const timeoutId = setTimeout(() => {
        navigate(redirectPath, { replace: true });
      }, 50);

      return () => clearTimeout(timeoutId);
    }
  }, [isAuthenticated, user, isLoading, navigate]);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#2E3E58] flex items-center justify-center">
        <div className="text-white text-xl">جاري التحميل...</div>
      </div>
    );
  }

  // If user is already logged in, show loading while redirecting
  if (isAuthenticated && user) {
    return (
      <div className="min-h-screen bg-[#2E3E58] flex items-center justify-center">
        <div className="text-white text-xl">جاري التوجيه...</div>
      </div>
    );
  }

  // If no token found, allow access to login page
  return children;
};

export default LoginGuard;
